import { Base } from '@studiometa/js-toolkit';
import { toggleClass } from '@studiometa/js-toolkit/utils';

export default class VariantDropdown extends Base {
  static config = {
    name: 'VariantDropdown',
    refs: ['toggle[]', 'dropdown[]', 'sizeItem'],
    log: true,
  };

  mounted() {
    this.$log('VariantDropdown mounted', this.$refs);
    this.$log(this.$refs.toggle);
  }

  onToggleClick({index}) {
    this.showDropdown(index);
  }

  showDropdown(index) {
    toggleClass(this.$refs.dropdown[index], 'hidden');
    toggleClass(this.$refs.toggle[index].querySelector('.dropdown-arrow'), 'open');
  }

  onSizeItemClick() {
    this.closeAllDropdowns();
  }

  /**
   *
   */
  onDocumentClick() {
    this.closeAllDropdowns();
  }

  syncSizeSelection(sizeValue) {
    // Mettre à jour tous les labels de taille dans les deux dropdowns
    const sizeLabels = document.querySelectorAll('[data-variant-size-label], [data-sticky-size-label]');
    sizeLabels.forEach((label) => {
      label.textContent = sizeValue;
    });

    // Mettre à jour tous les items avec cette taille
    const allSizeItems = document.querySelectorAll('.size-dropdown-item');
    allSizeItems.forEach((item) => {
      const itemValue = item.getAttribute('data-size-value');
      if (itemValue === sizeValue) {
        item.classList.add('selected', 'bg-gray-100');
        const input = item.querySelector('input[type="radio"]');
        if (input) {
          input.checked = true;
        }
      } else {
        item.classList.remove('selected', 'bg-gray-100');
      }
    });
  }

  syncColorSelection(colorValue, colorStyle) {
    // Mettre à jour tous les swatches de couleur dans les boutons
    const colorSwatches = document.querySelectorAll('[data-sticky-color-swatch]');
    colorSwatches.forEach((swatch) => {
      swatch.setAttribute('style', colorStyle);
    });

    // Mettre à jour tous les items avec cette couleur
    const allColorItems = document.querySelectorAll('.color-dropdown-item');
    allColorItems.forEach((item) => {
      const itemValue = item.getAttribute('data-color-value');
      if (itemValue === colorValue) {
        item.classList.add('selected', 'bg-gray-100');
        const input = item.querySelector('input[type="radio"]');
        if (input) {
          input.checked = true;
        }
      } else {
        item.classList.remove('selected', 'bg-gray-100');
      }
    });
  }

  closeAllDropdowns() {
   this.$refs.dropdown.forEach((dropdow) => {
      dropdow.classList.add('hidden')
    });
    document.querySelectorAll('.dropdown-arrow').forEach((arrow) => {
      arrow.classList.remove('open');
    });
  }
}
